import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Table } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";

class CovidKalendar extends Component {
  state = { novyTerminData: {} };

  componentDidMount = () => {
    this.nahrajKalendar();
  };

  nahrajKalendar = async () => {
    const kalendar = await httpService.post(
      config.apiEndpoint + "covid/kalendarVypis.php"
    );
    this.setState({
      loaded: true,
      kalendar: kalendar.data.casy,
      ordinace: kalendar.data.ordinace.ordinace,
    });
  };

  novyTermin = async () => {
    const { novyTerminData } = this.state;
    await httpService.post(
      config.apiEndpoint + "covid/kalendarNovyTermin.php",
      { novyTerminData }
    );
    this.setState({ novyTermin: false, novyTerminData: {} });
    this.nahrajKalendar();
  };

  zmenaTermin = async (datum, ordinace_id, cas_od, cas_do, attr, val, save) => {
    if (attr === "smazat" && !save) {
      if (window.confirm("Skutečně smazat?")) {
        this.zmenaTermin(datum, ordinace_id, cas_od, cas_do, attr, val, true);
      }
    }
    let { kalendar } = this.state;
    const index = kalendar.findIndex((k) => k.datum === datum);
    const index2 = kalendar[index].ordinace.findIndex(
      (o) => o.ordinace_id === ordinace_id
    );
    const index3 = kalendar[index].ordinace[index2].casy.findIndex(
      (c) => c.cas_od === cas_od && c.cas_do === cas_do
    );
    kalendar[index].ordinace[index2].casy[index3][attr] = val;
    this.setState({ kalendar });
    if (save) {
      await httpService.post(config.apiEndpoint + "covid/zmenaTerminu.php", {
        datum,
        ordinace_id,
        cas_od,
        cas_do,
        attr,
        val,
      });
      this.nahrajKalendar();
    }
  };

  render() {
    const {
      loaded,
      kalendar,
      novyTermin,
      novyTerminData,
      ordinace,
    } = this.state;
    return (
      <React.Fragment>
        {loaded ? (
          <React.Fragment>
            <Modal
              show={novyTermin}
              onHide={() => this.setState({ novyTermin: false })}
            >
              <Modal.Header closeButton>Nový termín</Modal.Header>
              <Modal.Body>
                <small>Datum</small>
                <input
                  type="date"
                  value={novyTerminData.datum}
                  name="datum"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      novyTerminData: {
                        ...novyTerminData,
                        [e.target.name]: e.target.value,
                      },
                    })
                  }
                />
                <small>Čas od</small>
                <input
                  type="time"
                  value={novyTerminData.cas_od}
                  name="cas_od"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      novyTerminData: {
                        ...novyTerminData,
                        [e.target.name]: e.target.value,
                      },
                    })
                  }
                />
                <small>Čas do</small>
                <input
                  type="time"
                  value={novyTerminData.cas_do}
                  name="cas_do"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      novyTerminData: {
                        ...novyTerminData,
                        [e.target.name]: e.target.value,
                      },
                    })
                  }
                />
                <small>Testovací místo</small>
                <select
                  name="ordinace_id"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      novyTerminData: {
                        ...novyTerminData,
                        [e.target.name]: e.target.value,
                      },
                    })
                  }
                >
                  <option value="">Zvol testovací místo</option>
                  {ordinace &&
                    ordinace.map((o) => (
                      <option value={o.ordinace_id} key={o.ordinace_id}>
                        {o.nazev}
                      </option>
                    ))}
                </select>
                <small>Interval testu (minuty)</small>
                <input
                  type="number"
                  value={novyTerminData.interval_rezervace}
                  name="interval_rezervace"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      novyTerminData: {
                        ...novyTerminData,
                        [e.target.name]: e.target.value,
                      },
                    })
                  }
                />
                <small>Konfigurace omezení</small>
                <input
                  type="text"
                  value={novyTerminData.omezeni}
                  name="omezeni"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      novyTerminData: {
                        ...novyTerminData,
                        [e.target.name]: e.target.value,
                      },
                    })
                  }
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={this.novyTermin}
                  disabled={
                    !(
                      novyTerminData.datum &&
                      novyTerminData.cas_od &&
                      novyTerminData.cas_do &&
                      novyTerminData.ordinace_id &&
                      novyTerminData.interval_rezervace &&
                      novyTerminData.datum !== "" &&
                      novyTerminData.cas_od !== "" &&
                      novyTerminData.cas_do !== "" &&
                      novyTerminData.ordinace_id !== "" &&
                      novyTerminData.interval_rezervace !== ""
                    )
                  }
                >
                  Vložit nový termín
                </Button>
              </Modal.Footer>
            </Modal>
            <Button onClick={() => this.setState({ novyTermin: true })}>
              Nový termín
            </Button>
            {kalendar && kalendar.length > 0 ? (
              <Table className="mt-3">
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Testovací místo</th>
                    <th>Čas od</th>
                    <th>Čas do</th>
                    <th>Interval</th>
                    <th>Omezení</th>
                    <th>Viditelné</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {kalendar.map((d, index) =>
                    d.ordinace.map((o, index2) =>
                      o.casy.map((c, index3) => (
                        <tr key={"cas" + index + "_" + index2 + "_" + index3}>
                          {index2 === 0 && index3 === 0 && (
                            <td rowSpan={d.pocet}>{d.datumFormatted}</td>
                          )}
                          {index3 === 0 && (
                            <td rowSpan={o.pocet}>{o.ordinace}</td>
                          )}
                          <td>
                            {c.pocet ? (
                              c.cas_od
                            ) : (
                              <input
                                type="time"
                                value={c.cas_od}
                                onChange={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "cas_od",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "cas_od",
                                    e.target.value,
                                    true
                                  )
                                }
                              />
                            )}
                          </td>
                          <td>
                            {c.pocet ? (
                              c.cas_do
                            ) : (
                              <input
                                type="time"
                                value={c.cas_do}
                                onChange={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "cas_do",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "cas_do",
                                    e.target.value,
                                    true
                                  )
                                }
                              />
                            )}
                          </td>
                          <td>
                            {c.pocet ? (
                              c.interval_rezervace
                            ) : (
                              <input
                                type="number"
                                value={c.interval_rezervace}
                                style={{ width: "52px" }}
                                onChange={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "interval_rezervace",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "interval_rezervace",
                                    e.target.value,
                                    true
                                  )
                                }
                              />
                            )}
                          </td>
                          <td>
                            <input
                              type="text"
                              value={c.omezeni}
                              onChange={(e) =>
                                this.zmenaTermin(
                                  c.datum,
                                  c.ordinace_id,
                                  c.cas_od,
                                  c.cas_do,
                                  "omezeni",
                                  e.target.value
                                )
                              }
                              onBlur={(e) =>
                                this.zmenaTermin(
                                  c.datum,
                                  c.ordinace_id,
                                  c.cas_od,
                                  c.cas_do,
                                  "omezeni",
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </td>
                          <td>
                            {c.pocet ? (
                              <span>Obs.: {c.pocet}</span>
                            ) : (
                              <input
                                type="checkbox"
                                checked={c.viditelne === "1"}
                                onChange={(e) =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "viditelne",
                                    e.target.checked ? "1" : "0",
                                    true
                                  )
                                }
                              />
                            )}
                          </td>
                          <td>
                            {!c.pocet && (
                              <Button
                                variant="danger"
                                onClick={() =>
                                  this.zmenaTermin(
                                    c.datum,
                                    c.ordinace_id,
                                    c.cas_od,
                                    c.cas_do,
                                    "smazat",
                                    true
                                  )
                                }
                              >
                                DEL
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))
                    )
                  )}
                </tbody>
              </Table>
            ) : (
              <div className="alert alert-danger">Nic tu není</div>
            )}
          </React.Fragment>
        ) : (
          <p>Loading...</p>
        )}
      </React.Fragment>
    );
  }
}

export default CovidKalendar;
